export const GET_COURSES = 'courses/GET_COURSES';
export const GET_SCHOOL_COURSES = 'courses/GET_SCHOOL_COURSES';
export const UPDATE_COURSE_BY_ID = 'courses/UPDATE_COURSE_BY_ID';
export const REMOVE_COURSE_BY_ID = 'courses/REMOVE_COURSE_BY_ID';
